import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Modal from '@cimpress/react-components/lib/Modal';
import CountryDisplay from './CountryDisplay';

class CountryModal extends PureComponent {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    countryCodes: PropTypes.arrayOf(String).isRequired,
    countryListType: PropTypes.string.isRequired
  };

  render() {
    const { onClose, show, countryCodes = [], countryListType } = this.props;
    const countryDisplays = countryCodes.map(countryCode => (
      <CountryDisplay key={countryCode} countryCode={countryCode} />
    ));

    return (
      <Modal show={show} title={countryListType} closeOnOutsideClick={true} onRequestHide={onClose} closeButton={true}>
        {countryDisplays}
      </Modal>
    );
  }
}

export default CountryModal;
